var map = {
	"./symbol_0.png": "9a43",
	"./symbol_1.png": "414f",
	"./symbol_10.png": "99ec",
	"./symbol_11.png": "9684",
	"./symbol_12.png": "750b",
	"./symbol_2.png": "79bd",
	"./symbol_3.png": "e1f5",
	"./symbol_4.png": "1e69",
	"./symbol_5.png": "c437",
	"./symbol_6.png": "6b28",
	"./symbol_7.png": "031c",
	"./symbol_8.png": "3cff",
	"./symbol_9.png": "6144"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7298";